import React from 'react';
import { Badge } from '../ui/badge';
import { formatDate } from '../../lib/utils';

export default function AdminAuditLog({ auditLogs }) {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Audit Log
        </h2>
        <p className="text-sm text-zinc-500 mt-1">Record of all administrative actions.</p>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Action</th>
              <th>Admin</th>
              <th>Target</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {auditLogs.map(log => (
              <tr key={log.id}>
                <td className="font-mono text-xs">{formatDate(log.timestamp)}</td>
                <td>
                  <Badge variant="outline" className="rounded-none">
                    {log.action_type.replace(/_/g, ' ')}
                  </Badge>
                </td>
                <td className="text-sm">{log.admin_email}</td>
                <td className="text-sm">{log.target_entity_type || '-'}</td>
                <td className="text-xs text-zinc-500 max-w-xs truncate">
                  {log.new_state ? JSON.stringify(log.new_state).substring(0, 50) + '...' : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
